import { render } from "./TheSuaChuaTruDenChieuSang.vue?vue&type=template&id=082c954a"
import script from "./TheSuaChuaTruDenChieuSang.vue?vue&type=script&lang=js"
export * from "./TheSuaChuaTruDenChieuSang.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__